module.exports = __webpack_public_path__ + "static/img/DKP2.a012354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DKP2.png
// module id = XXDJ
// module chunks = 26